<template>
  <section class="cards">
    <div class="wrapper">
      <div class="cards__inner">
        <div class="cards__layout">
          <slot name="aside"></slot>
          <slot name="cards"></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Main"
};
</script>

<style lang="scss">
@import "@/assets/_vars";
.main,
.aside {
  &__item {
    display: flex;
    flex-direction: column;
    padding: 40px 30px;
  }
}

.cards,
.news {
  &__layout {
    display: flex;
    justify-content: space-between;
  }

  &__inner {
    padding: 40px 0;
  }

  @media screen and (max-width: $max-sm) {
    &__layout {
      flex-direction: column;
    }
  }
}

.cards {
  &__volunteers,
  &__news {
    flex-basis: 100%;
  }

  @media screen and (min-width: $min-lg) {
    &__aside {
      flex-basis: 30%;
    }

    &__main {
      flex-basis: 65%;
    }
  }

  @media screen and (min-width: $min-md) and (max-width: $max-md) {
    &__aside {
      flex-basis: 45%;
    }

    &__main {
      flex-basis: 50%;
    }
  }
}

.card {
  flex-direction: column;
  background-color: $sec_bg;
  border-radius: 20px;
  box-shadow: 0 0 2px 1px rgba(#333, 0.1);
  transition: box-shadow 0.4s;

  &:hover {
    box-shadow: 0 5px 10px 1px rgba(#555, 0.1);
  }
}
</style>
